export const stringToAnchor = (string: string) =>
  `#${string.split(' ').join('-').toLowerCase()}`;
